import React from 'react'
import "./Footer.scss"
function Footer() {
    return (
        <footer className="footer">
            <section className="row align-items-center justify-content-between">
            <div>
            <h3>Techgeeksfirm.com</h3>
            </div>

            <div>
                <p>admin@techgeeksfirm.com</p>
            </div>


            <div>
                <p className="phone">+8087508377</p>
            </div>

                
            </section>
        </footer>
    )
}

export default Footer
